module.exports = __webpack_public_path__ + "static/img/home_showmore_photo4@2x.86965cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_showmore_photo4@2x.png
// module id = 0z7V
// module chunks = 0